import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { mainNav } from '../data/navigation';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);
  const isActive = (to: string) => to === '/policies' && location.pathname === '/policies';
  return <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur" data-id="element-51" data-mp="2wj5my0rw5x40">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8" data-id="element-52" data-mp="31cqno0kvd56w">
        <Logo data-id="element-53" data-mp="36aa333tazo0f" />
        <nav aria-label="Main" className="hidden items-center gap-1 md:flex" data-id="element-54" data-mp="36cwa92ca81i4">
          {mainNav.map(item => <Link key={item.to} to={item.to} aria-current={isActive(item.to) ? 'page' : undefined} className={`rounded-md px-3 py-2 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${isActive(item.to) ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-55" data-mp="3fbq4im254fsi">
              {item.label}
            </Link>)}
          <Link to="/#products" className="ml-3 whitespace-nowrap rounded-md bg-accent px-4 py-2 text-sm font-semibold text-paper transition-colors duration-150 hover:bg-accent-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-56" data-mp="2hpoiccjebufl">
            Browse products
          </Link>
        </nav>
        <button type="button" onClick={() => setOpen(v => !v)} className="rounded-md p-2 text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent md:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-57" data-mp="30lodtxbl1g3x">
          {open ? <XIcon className="h-5 w-5" data-id="element-58" data-mp="1wco6fuvktc4b" /> : <MenuIcon className="h-5 w-5" data-id="element-59" data-mp="1wcxqz2xuqr2m" />}
        </button>
      </div>
      <AnimatePresence data-id="element-60" data-mp="1hnruhmqefeyf">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-paper px-5 pb-5 pt-2 md:hidden" data-id="element-61" data-mp="1hmytl2e4fjo7">
            {mainNav.map(item => <Link key={item.to} to={item.to} onClick={() => setOpen(false)} className={`block rounded-md px-3 py-3 text-base font-medium ${isActive(item.to) ? 'bg-canvas text-ink' : 'text-muted'}`} data-id="element-62" data-mp="yqgvm38oinji">
                {item.label}
              </Link>)}
          </motion.nav>}
      </AnimatePresence>
    </header>;
}